// extracted by mini-css-extract-plugin
export default {"buttonOverlay":"ScopeSelector_buttonOverlay__thZh2"};